<app-header apdTitle="Construction Insight Admin" logoClickUrl="/"> </app-header>
<div class="page-container">
  <nav mat-tab-nav-bar>
    <a
      mat-tab-link
      routerLink="/admin/users"
      routerLinkActive
      #usersLink="routerLinkActive"
      [active]="usersLink.isActive"
    >
      Users
    </a>
    <a
      mat-tab-link
      routerLink="/admin/locations"
      routerLinkActive
      #locationsLink="routerLinkActive"
      [active]="locationsLink.isActive"
    >
      Locations
    </a>
    <a
      mat-tab-link
      routerLink="/admin/projects"
      routerLinkActive
      #projectsLink="routerLinkActive"
      [active]="projectsLink.isActive"
    >
      Projects
    </a>
    <a
      mat-tab-link
      routerLink="/admin/customer-sites"
      routerLinkActive
      #customerSitesLink="routerLinkActive"
      [active]="customerSitesLink.isActive"
    >
      Customer Sites
    </a>
    <a
      mat-tab-link
      routerLink="/admin/release-notes"
      routerLinkActive
      #releaseNotesLink="routerLinkActive"
      [active]="releaseNotesLink.isActive"
    >
      Release Notes
    </a>
    <a
      mat-tab-link
      routerLink="/admin/statistics"
      routerLinkActive
      #statisticsLink="routerLinkActive"
      [active]="statisticsLink.isActive"
    >
      Statistics
    </a>
    <a
      mat-tab-link
      routerLink="/admin/weight-change-categories"
      routerLinkActive
      #weightCatLink="routerLinkActive"
      [active]="weightCatLink.isActive"
    >
      Weight Categories
    </a>
  </nav>
  <div class="main-container">
    <div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
